import { Alert, Box, Typography } from '@mui/material';
import { Stack } from '@mui/joy';
import { useSelector } from 'react-redux';
import { useGetShopifyStoresHandler } from '../dataHandlers/getShopifyStoresHandler';
import ShopifyStoreCard from './ShopifyStoreCard';

const ShopifyIntegrationTab = () => {
  const org = useSelector((state) => state.org.org);
  const user = useSelector((state) => state.org.org.user);
  const shopifyStores = useGetShopifyStoresHandler(org._id).stores;

  return (
    <Box
      sx={{
        width: '100%',
        p: 3,
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: 2,
        backgroundColor: 'white',
        mt: 2,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        Shopify Integration
      </Typography>

      <Stack spacing={2}>
        <Box>
          {shopifyStores.length > 0 ? (
            shopifyStores.map((store, index) => <ShopifyStoreCard store={store} key={store._id} />)
          ) : (
            <Alert severity="error" sx={{ fontSize: '16px', marginBottom: '-10px' }}>
              <>
                No Shopify stores found for <strong>{user?.email || ''}</strong> account.
              </>
            </Alert>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default ShopifyIntegrationTab;
